import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IBizEntity } from '@optima-stride-ai/core';

export interface ContextMenuClickEvent {
  entity: IBizEntity;
  event: MouseEvent;
}

@Injectable({
  providedIn: 'root'
})
export class FileSheetFooterService {
  private contextMenuClickSubject = new Subject<ContextMenuClickEvent>();
  
  contextMenuClick$ = this.contextMenuClickSubject.asObservable();

  emitContextMenuClick(entity: IBizEntity, event: MouseEvent): void {
    this.contextMenuClickSubject.next({ entity, event });
  }
}
